module.exports = __webpack_public_path__ + "static/img/right.d27b65a1.png";